import {defineMessage} from 'react-intl';
import html from './html/html';
import success from './html/success';
import cancel from './html/cancel';
import js from './html/js';
import htmlSteps from './html/steps';
import react from './react/index';
import reactSteps from './react/steps';
import node, {steps as nodeSteps} from './server/node';
import ruby, {steps as rubySteps} from './server/ruby';
import python, {steps as pythonSteps} from './server/python';
import php, {steps as phpSteps} from './server/php';
import phpCreate from './server/php-portal';
import phpWebhooks from './server/php-webhooks';
import java, {steps as javaSteps} from './server/java';
import go, {steps as goSteps} from './server/go';
import dotnet, {steps as dotnetSteps} from './server/dotnet';
import docs from './build';

export const sections = [
  {
    id: 'create-pricing-model',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.billing.sections.create-pricing-model',
        defaultMessage: 'Create pricing model',
      }),
    },
  },
  {
    id: 'build-page',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.billing.sections.build-page',
        defaultMessage: 'Build your subscription page',
      }),
    },
  },
  {
    id: 'setup-stripe',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.billing.sections.setup-stripe',
        defaultMessage: 'Add endpoints for Checkout and customer portal',
      }),
    },
  },
  {
    id: 'testing',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.billing.sections.testing',
        defaultMessage: 'Test your page',
      }),
    },
  },
];

export const integrations = {
  docs,
  html: {
    steps: htmlSteps,
    files: {
      html: {
        builder: html,
        language: 'html',
        name: 'public/index.html',
      },
      js: {builder: js, language: 'js', name: 'public/client.js'},
      success: {
        builder: success,
        language: 'html',
        name: 'public/success.html',
      },
      cancel: {builder: cancel, language: 'html', name: 'public/cancel.html'},
    },
  },
  react: {
    steps: reactSteps,
    files: {
      react: {
        builder: react,
        language: 'jsx',
        name: 'src/App.js',
      },
    },
  },
  node: {
    files: {
      node: {
        builder: node,
        language: 'js',
        name: 'server.js',
      },
    },
    steps: nodeSteps,
  },
  ruby: {
    files: {
      ruby: {
        builder: ruby,
        language: 'ruby',
        name: 'server.rb',
      },
    },
    steps: rubySteps,
  },
  python: {
    files: {
      python: {
        builder: python,
        language: 'python',
        name: 'server.py',
      },
    },
    steps: pythonSteps,
  },
  php: {
    files: {
      php: {
        builder: php,
        language: 'php',
        name: 'create-checkout-session.php',
      },
      phpCreate: {
        builder: phpCreate,
        language: 'php',
        name: 'create-portal-session.php',
      },
      phpWebhooks: {
        builder: phpWebhooks,
        language: 'php',
        name: 'webhooks.php',
      },
    },
    steps: phpSteps,
  },
  java: {
    files: {
      java: {
        builder: java,
        language: 'java',
        name: 'Server.java',
      },
    },
    steps: javaSteps,
  },
  go: {
    files: {
      go: {
        builder: go,
        language: 'go',
        name: 'Server.go',
      },
    },
    steps: goSteps,
  },
  dotnet: {
    files: {
      dotnet: {
        builder: dotnet,
        language: 'dotnet',
        name: 'Server.cs',
      },
    },
    steps: dotnetSteps,
  },
};

export default {
  integrations,
  sections,
};
